export const GET_COMMENTS = '/api/TraceableComment/get-traceable-comments';

export const GET_QA_WORKFLOW_COMMENTS =
  '/api/TraceableComment/get-qaworkflow-traceable-comment-status';

export const UPDATE_COMMENT_STATUS =
  '/api/TraceableComment/save-or-update-qaworkflow-traceable-comment-status';

export const SAVE_COMMENTS =
  '/api/TraceableComment/save-or-update-traceable-comment';

export const GET_COMMENT_COUNT =
  'api/TraceableComment/get-traceable-comments-count';

export const PUT_COMMENT_COUNT =
  'api/TraceableComment/update-traceable-comments-count';
